export const LISTENER_ACTION_OPEN = "OPEN_SOCKET";
export const LISTENER_ACTION_CLOSE = "CLOSE_SOCKET";

export const MODELS_UPDATED = "MODELS_UPDATED";
